import React from "react";
import { Box, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MzAccordion, MzAccordionDetails, MzAccordionSummary } from "@markaaz/ui/MzAccordionControls";
import MzCheckbox from "@markaaz/ui/MzCheckbox";

const sx = {
  checkboxWrapper: {
    position: "absolute",
    top: 0,
    lineHeight: "45px"
  }
};

export default function CheckboxAccordian({
  label,
  children,
  onChange,
  checked,
  onCheckboxClick,
  defaultExpanded,
  disabled = false
}) {
  const isChildrenExist = !!children;
  return (
    <MzAccordion onChange={onChange} defaultExpanded={defaultExpanded}>
      <MzAccordionSummary expandIcon={isChildrenExist ? <ExpandMoreIcon /> : null}>
        <Box
          sx={sx.checkboxWrapper}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <MzCheckbox checked={checked} onChange={onCheckboxClick} disabled={disabled} />
        </Box>
        <Typography
          variant="body1B"
          sx={{
            paddingLeft: "45px"
          }}
        >
          {label}
        </Typography>
      </MzAccordionSummary>
      <MzAccordionDetails>{children}</MzAccordionDetails>
    </MzAccordion>
  );
}
